// aws
import config from '../config';
import Request from './request';

const { aws: { api: { invokeUrl } } } = config;

// eslint-disable-next-line import/prefer-default-export
export const getJobApplications = (pointer, limit) => Request.get(`${invokeUrl}/admin/jobApplications?limit=${limit}&pointer=${pointer}`, true);
